import { useEffect, useState } from "react";
import { CheckboxValueType } from "antd/lib/checkbox/Group";
import { ColumnType } from "antd/es/table/interface";
import { isObject } from 'lodash'

export function useCustomColumns(
  column: ColumnType<any>[],
  key: string,
  options?: { defaultUnchecked?: string[] }
) {
  const { defaultUnchecked = [] } = options ?? {};

  const [openModal, setOpenModal] = useState(false);

  const defaultCheckData: CheckboxValueType[] =
    column.filter(item => item.key !== 'operation')
      .map((i) => String(i.key || i.dataIndex))
      .filter((i) => !defaultUnchecked.includes(i?.toString() ?? "")) || [];

  const [checkedValue, setCheckedValue] = useState<CheckboxValueType[]>([]);

  const isObjectValue = () => {
    return isObject(localStorage.getItem(key))
  }

  const onChange = (v: CheckboxValueType[]) => {
    setCheckedValue(v);
    localStorage.setItem(key, isObjectValue() ? JSON.stringify(v) : v.join(','));
  };

  const updateCheckedValue = () => {
    const storeValue = localStorage.getItem(key);
    const _checkedValue: CheckboxValueType[] = storeValue
      ? isObjectValue() ? JSON.parse(storeValue) : storeValue.split(',')
      : defaultCheckData;
    setCheckedValue(_checkedValue)
    return _checkedValue
  }
  useEffect(() => {
    updateCheckedValue()
  }, [])

  return {
    defaultCheckData,
    openModal,
    setOpenModal,
    checkedValue,
    onChange,
    setCheckedValue,
    updateCheckedValue,
  };
}
